import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function ResourceLinks({ data }) {
    return (
        <div key={data.documentId} className="resource-links">
            <div className="views-row views-row-5 views-row-odd screen-width light-gray-background node node-resource-links-band node-promoted node-teaser clearfix">

                    <div className="container-fluid news-container max-width" id="links" style={{paddingTop: '50px'}}>
                        {/*style={{ maxWidth: "1370px" }}*/}
                        <div className="row">
                            <div className="col-sm-12 no-padding">
                                <p className="section-headline-small pull-left">
                                    LINKS
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div>
                                <hr style={{ borderTop: "2px solid #333", marginTop: '-5px', marginBottom: '-5px'}} />
                            {/*previous color    #c9cacb*/}
                            </div>

                            <div className={'resource-links-grid'}>
                                {data.organizationLinks.map((organizationLink, organizationLinkIdx) => (
                                    <div key={ organizationLinkIdx } className="col-sm-3 resource-links" style={{width:'95%', paddingLeft:'20px', paddingRight:'20px'}}>

                                        <div className="">
                                            <p className="bold">{ organizationLink.category }</p>
                                        </div>

                                        {organizationLink.links.map((link, linkIdx) => (
                                            <div key={ linkIdx } className="">
                                                <a target="_blank" href={ link.url } className="">{ link.label }</a>
                                            </div>
                                        ))}

                                    </div>
                                ))}
                            </div>

                        </div>

                    </div>

            </div>
        </div>
    );
}

export default ResourceLinks;
